import { makeAutoObservable } from 'mobx';
import lmsIntegrationAgent from '../services/api/lmsIntegrationAgent';
import { ILinkedIntegration } from '../routes/courseDashboard/features/dashboardViews/PublishCourseView';
import { ILMSUpdateLinkItem } from '../services/models/LMSLinkModel';

export interface IMentorkitLMSCourseList {
  CourseId: number;
  Name: string;
}

interface ITargetCourseList {
  lmsCustomerId: number;
  courseList: IMentorkitLMSCourseList[];
}

export default class PublishStore {
  targetCourseList: ITargetCourseList = { lmsCustomerId: 0, courseList: [] };
  isTargetCourseListLoaded = false;

  constructor() {
    makeAutoObservable(this);
  }

  getTargetCourseList = async (aTargetLmsID: number) => {
    if (this.targetCourseList.lmsCustomerId == aTargetLmsID) return;
    this.isTargetCourseListLoaded = false;

    const courseList = await lmsIntegrationAgent.MentorkitLms.GetCourseList(aTargetLmsID);
    if (courseList.length > 0) {
      this.targetCourseList = { lmsCustomerId: aTargetLmsID, courseList };
      this.isTargetCourseListLoaded = true;
    }
  };

  updateLMSLink = async (aTargetCourseID: number, aIntegration: ILinkedIntegration) => {
    const targetCourse = this.targetCourseList.courseList.find((x) => x.CourseId === aTargetCourseID);
    if (!targetCourse) {
      console.error(`Cant find target course ${aTargetCourseID}`);
      return;
    }
    if (!aIntegration.courseLMSLink || !targetCourse) {
      return;
    }

    aIntegration.courseLMSLink.lmsCourseName = targetCourse.Name;
    aIntegration.courseLMSLink.identifierLMSCourse = targetCourse.CourseId.toString();

    const updateLMSLink: ILMSUpdateLinkItem = {
      lmsCustomerId: aIntegration.courseLMSLink.lmsCustomerId,
      lmsCustomerCourseId: aIntegration.courseLMSLink.lmsCustomerCourseId,
      lmsCourseName: targetCourse.Name,
      identifierLMSCourse: targetCourse.CourseId.toString(),
    };

    return lmsIntegrationAgent.CourseLMSLink.updateLMSLink(updateLMSLink);
  };

  getPublishLogs = async (aCourseID: number) => {
    return await lmsIntegrationAgent.CourseLMSLink.getPublishLogsByCourse(aCourseID);
  };
}
